const baseurl = {
  apiUrl: process.env.REACT_APP_API_BASE_URL,
  baseUrl: process.env.REACT_APP_BASE_URL,
};
export const PATH = {
  baseApi: baseurl.apiUrl,
  base: baseurl.baseUrl,
};
